module.exports = __webpack_public_path__ + "img/holiday-pack.b1bb5f5c.webp";